export default "__VITE_ASSET__0c1f5b19__"